import { faBoltLightning, faMapMarker, faThumbtack } from '@fortawesome/pro-regular-svg-icons';
import { FilterType } from '../models/MissionFilterType';
import { useAppSelector } from './store-hook';
import useTranslation from './translation-hook';

export default function useMissionTypeFilters() {
  const t = useTranslation();
  const language = useAppSelector(state => state.userPrefs.uiLanguage);

  return [
    { value: FilterType.All, label: t('all') },
    { value: FilterType.Classic, label: t('Classic'), icon: faMapMarker },
    { value: FilterType.Flash, label: t('Flash'), icon: faBoltLightning },
    {
      value: FilterType.Featured,
      label: t('Featured', { defaultValue: language?.startsWith('fr') ? 'En vedette' : 'Featured' }),
      icon: faThumbtack,
    },
    { value: FilterType.AgeRestricted, label: t('age-restricted-filter', { defaultValue: language?.startsWith('fr') ? "Restriction d’âge" : 'Age restricted' }) },
  ];
}
